import ImageFormView from "./ImageFormView";

function ImageForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  images,
}) {
  /**
   * This method will handle the image change event for the selected label item.
   * @param {int} value
   */
  function onImageChange(value) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              image_id: value,
            }
          : item
      ),
    }));
  }

  return (
    <ImageFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      images={images}
      onImageChange={onImageChange}
      submitError={submitError}
    />
  );
}

export default ImageForm;
